import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AssessmentList from './List';
import AssessmentCreate from './Create';
import AssessmentDetail from './Detail';

const defaultFields = {
    CompensationEvent: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    ContinuingEffect: { visible: false, label: '', required: false },
    Subject: { visible: false, label: '', required: false },
    TaskOrder: { visible: false, label: '', required: false },
    ProjectOrder: { visible: false, label: '', required: false },
    PriceEffect: { visible: false, label: '', required: false },
    TimeEffect: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
}


const interimSelectionOptions = [
    { value: 0, display: "FINAL" },
    { value: 1, display: "INTERIM" }
];
///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];

    if (wfid === 8) {
        fields.CompensationEvent = { visible: true, label: resources.AssessmentCompensationLabel, required: true };
    }
    if (wfid === 51) {
        let clauses = workflowItem.clauses;
        if (!clauses && placeholdersQA.VariationClauses) {
            clauses = placeholdersQA.VariationClauses.values.filter(item => item.isActive === true);
        }
        fields.Type = { visible: true, label: resources.AssessmentCompensationLabel, required: true };
        fields.Type.clauses = clauses;
    }
    if (wfid === 8 && placeholdersQA.INTERIM_QUOTES_ALLOWED) {
        const interimQuotesAllowed = placeholdersQA.INTERIM_QUOTES_ALLOWED.values.find(phItem => phItem.field === 'INTERIM_QUOTES_ALLOWED').isActive;
        if (interimQuotesAllowed) {
            fields.ContinuingEffect = { visible: true, label: "Continuing Effect", required: true };
            fields.ContinuingEffect.interimSelectionOptions = interimSelectionOptions;
        }
    }

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    if (wfid === 50 || wfid === 51) {
        if (placeholdersQA.TaskOrderOptionEnabled) {
            const taskOrderOptionEnabled = placeholdersQA.TaskOrderOptionEnabled.values
                .find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive;
            if (taskOrderOptionEnabled) {
                const taskOrderNotificationName = (workflowsQA['38'] || {}).notificationName;
                const taskOrderLabel = languageFile["CONTRACT.WF.COMPENSATION.FIELD.TASK_ORDER"].replace("{TASK_ORDER}", taskOrderNotificationName);
                fields.TaskOrder = { visible: true, label: taskOrderLabel, required: true };
            }
        }
        if (placeholdersQA.ProjectOrderOptionEnabled) {
            const projectOrderOptionEnabled = placeholdersQA.ProjectOrderOptionEnabled.values
                .find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive;
            if (projectOrderOptionEnabled) {
                const projectOrderNotificationName = (workflowsQA['72'] || {}).notificationName;
                const projectOrderLabel = languageFile["CONTRACT.WF.COMPENSATION.FIELD.PROJECT_ORDER"].replace("{PROJECT_ORDER}", projectOrderNotificationName);
                fields.ProjectOrder = { visible: true, label: projectOrderLabel, required: true };
            }
        }

    }
    if (contract?.ispackaged !== true && (wfid === 8 || wfid === 51)) {
        fields.PriceEffect = { visible: true, label: resources.AssessmentCostEffectLabel, required: true };
    }
    if (wfid === 8 || wfid === 50) {
        fields.TimeEffect = { visible: true, label: resources.AssessmentDaysEffectLabel, required: true };
    }

    fields.Details = { visible: true, label: resources.AssessmentDetailLabel, required: true };

    return fields;
}



class AssessmentRouter extends React.Component {
    constructor(props) {
        super(props);

        if (props.mode === 'PM') {
            this.documentType = 'Document614pm';
        }
        else if (props.mode === 'PM_TIME') {
            this.documentType = 'DocumentAssessmentTime';
        }
        else if (props.mode === 'PM_PRICE') {
            this.documentType = 'DocumentAssessmentPrice';
        }

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;



    }
    getClauses(key) {
        const placeholder = this.props.placeholders.find(ph => ph.replacementKey === key);
        if (placeholder) {
            return placeholder.values.filter(item => item.isActive === true);
        }
        return null;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <Routes caseSensitive>
                <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<AssessmentList
                        {...this.props}

                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}

                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <AssessmentCreate
                                {...this.props}
                                mode={this.props.mode}
                                title={this.notificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<AssessmentDetail
                        {...this.props}
                        mode={this.props.mode}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};




export default (AssessmentRouter);